
import { defineComponent } from "vue";
import { SpeakerphoneIcon } from "@heroicons/vue/outline";

export default defineComponent({
  setup() {
    const posts: any = [
      //   {
      //     title: "Boutique de Noël",
      //     id: "14",
      //     category: { name: "Informations", href: "#" },
      //     resume: "Des supers offres sur du textile aux couleurs du club",
      //     description:
      //       "Le club est heureux de vous proposer des supers offres sur du textile aux couleurs du club, ces produits de grande qualité pourront être au pied du sapin s'ils sont commandés avant le 30/11. \n\n Vous trouverez donc en PJ les visuels des produits ainsi que le bon de commande pour (vous) faire plaisir. \n\n Si vous avez des questions n'hésitez pas et ne tardez pas pour vos commandes. \n\n ![affiche](https://mdhzltncrguobwkttodh.supabase.co/storage/v1/object/public/SEHC/cover_news/boutique_noel/1.jpg?t=2023-11-16T18%3A07%3A14.068Z)\n\n ![affiche](https://mdhzltncrguobwkttodh.supabase.co/storage/v1/object/public/SEHC/cover_news/boutique_noel/2.jpg?t=2023-11-16T18%3A07%3A14.068Z)\n\n ![affiche]()\n\n ![affiche](https://mdhzltncrguobwkttodh.supabase.co/storage/v1/object/public/SEHC/cover_news/boutique_noel/3.jpg?t=2023-11-16T18%3A08%3A12.719Z)\n\n ![affiche](https://mdhzltncrguobwkttodh.supabase.co/storage/v1/object/public/SEHC/cover_news/boutique_noel/4.jpg?t=2023-11-16T18%3A08%3A20.238Z)\n\n ![affiche](https://mdhzltncrguobwkttodh.supabase.co/storage/v1/object/public/SEHC/cover_news/boutique_noel/5.jpg?t=2023-11-16T18%3A08%3A26.232Z)\n\n ![affiche](https://mdhzltncrguobwkttodh.supabase.co/storage/v1/object/public/SEHC/cover_news/boutique_noel/6.jpg?t=2023-11-16T18%3A08%3A33.316Z)\n\n",
      //     date: "16 NOVEMBRE 2023",
      //     datetime: "",
      //     imageUrl:
      //       "https://mdhzltncrguobwkttodh.supabase.co/storage/v1/object/public/SEHC/cover_news/boutique_noel.png?t=2023-11-16T18%3A00%3A46.987Z",
      //     readingTime: "1 min",
      //     author: {
      //       name: "Manu",
      //       href: "#",
      //       imageUrl: "https://sehc.asso-web.com/uploaded/manu.jpg",
      //     },
      //   },
    ];
    return {
      posts,
    };
  },
  components: {
    //SpeakerphoneIcon,
  },
});
